export default {"src":"/_next/static/media/Crohn.4353e3b3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};